import React, { useEffect, useRef, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Login } from "@microsoft/mgt-react";
import { FaUserShield, FaUsers, FaUserCircle } from "react-icons/fa";
import { FiSettings, FiServer } from "react-icons/fi";

function Header({
  isSignedIn,
  checkGroupAdresse,
  checkGroupAdmin,
  checkGroupNom,
  checkGroupReseauInfo,
  checkGroupInfoBancaire,
  checkGroupAntCriminels,
  checkGroupRecMensuelle,
  checkGroupSeancePlacement,
  routesConfig,
  existMembre
}) {
  const navigate = useNavigate();
  const [isInactive, setIsInactive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); // Reference for the dropdown menu
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(120); // 2 minutes = 120 secondes
  const [mobileOpen, setMobileOpen] = useState(false);
  // const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
  const asideRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        asideRef.current &&
        !asideRef.current.contains(event.target) &&
        mobileOpen
      ) {
        setMobileOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileOpen]);

  useEffect(() => {
    const loginComponent = document.querySelector("mgt-login");

    const handleLogout = () => {
      navigate("/");
    };

    // Add an event listener to log the sign-in process
    const handleLoginSuccess = () => {
      // console.log('User successfully signed in');
      navigate("/"); // or redirect to the desired page after login
    };

    const handleLoginError = (event) => {
      console.error("Login error:", event.detail);
    };

    if (loginComponent) {
      loginComponent.addEventListener("logoutInitiated", handleLogout);
      loginComponent.addEventListener("loginSuccess", handleLoginSuccess);
      loginComponent.addEventListener("loginError", handleLoginError);
    }

    return () => {
      if (loginComponent) {
        loginComponent.removeEventListener("logoutInitiated", handleLogout);
        loginComponent.removeEventListener("loginSuccess", handleLoginSuccess);
        loginComponent.removeEventListener("loginError", handleLoginError);
      }
    };
  }, [navigate]);

  const location = useLocation();

  useEffect(() => {
    let inactivityTimeout;
    let warningTimeout;
    let countdownInterval;

    const resetTimer = () => {
      clearTimeout(inactivityTimeout);
      clearTimeout(warningTimeout);
      clearInterval(countdownInterval);
      setShowWarning(false);
      // setCountdown(120);
      // Determine timeout based on route
      const isShortTimeout =
        location.pathname === "/taches" || location.pathname === "/groupRoles";
      const totalInactivity = isShortTimeout ? 30 * 60 * 1000 : 60 * 60 * 1000; // 15 or 40 minutes
      const warningTime = isShortTimeout ? 28 * 60 * 1000 : 58 * 60 * 1000; // 2 minutes before logout

      const countdownStart = 120; // seconds
      setCountdown(countdownStart);

      // Affiche l’alerte après 18 min
      warningTimeout = setTimeout(() => {
        setShowWarning(true);
        // setCountdown(120); // recommence à 120 sec
        setCountdown(countdownStart);
        countdownInterval = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(countdownInterval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }, warningTime);

      inactivityTimeout = setTimeout(() => {
        setIsInactive(true);
        setShowWarning(false);
        clearInterval(countdownInterval);
      }, totalInactivity); // 15 minutes
    };

    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;

    return () => {
      clearTimeout(inactivityTimeout);
      clearTimeout(warningTimeout);
      clearInterval(countdownInterval);
    };
  }, [location.pathname]);

  useEffect(() => {
    if (isInactive) {
      const loginComponent = document.querySelector("mgt-login");
      if (loginComponent) {
        loginComponent.logout();
      }
    }
  }, [isInactive]);

  // // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setDropdownOpen(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // const handleOptionClick = () => {
  //   setDropdownOpen(false); // Close the dropdown when an option is clicked
  // };

  return (
    <div className="flex min-h-screen ">
      {/* Sidebar */}
      {/* <aside className="min-w-48 max-w-[14%] w-auto min-h-full bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white p-6 shadow-2xl flex flex-col transition-all duration-300"> */}
      <aside
        ref={asideRef}
        className={`fixed top-0 left-0 min-w-48 max-w-[14%] w-auto min-h-full bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white p-6 shadow-2xl flex flex-col transition-all duration-300
        ${mobileOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 md:relative md:w-auto`}
      >
        {/* Logo */}
        <img
          src={`${process.env.PUBLIC_URL}/csv.png`}
          alt="Logo"
          className="w-48 h-auto mb-10 mx-auto transition-transform duration-300 hover:scale-105"
        />

        {/* Navigation */}
        <nav className="flex-1">
          <ul className="flex flex-col gap-3">
            {isSignedIn && (
              <>
                {/* Dropdown Formulaires */}
                <li ref={dropdownRef} className="relative">
                  <button
                    onClick={toggleDropdown}
                    className={`w-full flex items-center justify-between py-3 px-4 rounded-2xl text-white font-semibold transition-all duration-300 ${
                      dropdownOpen
                        ? "bg-gradient-to-r from-blue-600 to-blue-500 shadow-lg"
                        : "bg-gray-700 hover:bg-gray-600 hover:shadow-md"
                    }`}
                  >
                    Formulaires
                    <svg
                      className={`h-5 w-5 ml-2 transition-transform duration-300 ${
                        dropdownOpen ? "rotate-180" : "rotate-0"
                      }`}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                    {dropdownOpen && (
                      <ul className="mt-2 w-full bg-gray-700 rounded-2xl shadow-lg overflow-hidden animate-fadeIn">
                        {routesConfig
                          .filter((r) => {
                            // if (!r.enabled) return false; 

                            // Cas spécial : Form FEESO
                            if (r.label === "Form FEESO") {
                              return (
                                existMembre === "exist dans FEESO" ||
                                checkGroupAdmin ||
                                checkGroupSeancePlacement
                              );
                            }

                            // Cas spécial : Form SCFP
                            if (r.label === "Form SCFP") {
                              return (
                                existMembre === "exist dans SCFP" ||
                                checkGroupAdmin ||
                                checkGroupSeancePlacement
                              );
                            }

                            // Cas spécial : Form AEFO
                            if (r.label === "Form AEFO") {
                              return (
                                existMembre === "exist dans AEFO" ||
                                checkGroupAdmin ||
                                checkGroupSeancePlacement
                              );
                            }

                            // Toutes les autres routes
                            return true;
                          })
                          .sort((a, b) => a.label.localeCompare(b.label, "fr"))
                          .map(({ path, label }) => (
                            <NavLink
                              key={path}
                              to={path}
                              className={({ isActive }) =>
                                `text-sm py-2 px-4 block rounded-xl transition-all duration-300 ${
                                  isActive
                                    ? "bg-blue-600 text-white shadow-inner"
                                    : "text-white bg-gray-700 hover:bg-gray-600"
                                }`
                              }
                            >
                              {label}
                            </NavLink>
                          ))}
                      </ul>
                    )}
                </li>

                {/* Liens fixes */}
                {[
                  { path: "/demande", label: "Mes demandes" },
                  { path: "/taches", label: "Mes tâches" },
                ].map(({ path, label }) => (
                  <li key={path}>
                    <NavLink
                      to={path}
                      className={({ isActive }) =>
                        `w-full block py-3 px-4 rounded-2xl font-medium transition-all duration-300 ${
                          isActive
                            ? "bg-blue-600 text-white shadow-lg"
                            : "bg-gray-700 hover:bg-gray-600 hover:shadow-md"
                        }`
                      }
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}

                {(checkGroupAdmin || checkGroupRecMensuelle ||checkGroupInfoBancaire || checkGroupAntCriminels) && (
                  <li>
                    <NavLink
                      to="/Archives"
                      className={({ isActive }) =>
                        `w-full block py-3 px-4 rounded-2xl font-medium transition-all duration-300 ${
                          isActive
                            ? "bg-blue-600 text-white shadow-lg"
                            : "bg-gray-700 hover:bg-gray-600 hover:shadow-md"
                        }`
                      }
                    >
                      Archives
                    </NavLink>
                  </li>
                )}


                {/* Admin-only link */}
                {checkGroupAdmin && (
                  <li>
                    <NavLink
                      to="/groupRoles"
                      className={({ isActive }) =>
                        `w-full block py-3 px-4 rounded-2xl font-medium transition-all duration-300 ${
                          isActive
                            ? "bg-blue-600 text-white shadow-lg"
                            : "bg-gray-700 hover:bg-gray-600 hover:shadow-md"
                        }`
                      }
                    >
                      Groupes
                    </NavLink>
                  </li>
                )}
              </>
            )}
          </ul>
        </nav>
      </aside>

      {/* Main Content Area */}

      <main className="flex-1 p-1">
        <nav className="flex justify-between items-center mb-1 shadow-lg p-1">
          {/* Admin or Task Manager Badge */}
          {/* Left-Side Badges */}
          {isSignedIn && !mobileOpen && (
          <div className="md:hidden flex flex-wrap items-center gap-3 mr-4">
            <div className="md:hidden p-4 z-30 relative">
              <button onClick={() => setMobileOpen(!mobileOpen)} className="focus:outline-none">
  <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
</button>
            </div>
          </div>)}

          <div className="flex flex-wrap items-center gap-3 mr-4">
            {isSignedIn && checkGroupAdmin && (
              <div className="flex items-center bg-green-600 text-white py-2 px-2 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300">
                <FaUserShield className="mr-2 text-xl" />
                <span className="font-semibold text-md">Administrateur</span>
              </div>
            )}
            {isSignedIn &&
              (checkGroupAdresse ||
                checkGroupNom ||
                checkGroupReseauInfo ||
                checkGroupInfoBancaire ||
                checkGroupAntCriminels ||
                checkGroupRecMensuelle ||
              checkGroupSeancePlacement) &&
              !checkGroupAdmin && (
                <div className="flex items-center bg-indigo-600 text-white py-2 px-4 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300">
                  <FaUsers className="mr-2 text-xl" />
                  <span className="font-semibold text-md">
                    Gestionnaire de tâches
                  </span>
                </div>
              )}
            {isSignedIn &&
              !(
                checkGroupAdresse ||
                checkGroupNom ||
                checkGroupReseauInfo ||
                checkGroupInfoBancaire ||
                checkGroupAntCriminels ||
                checkGroupRecMensuelle ||
                checkGroupSeancePlacement ||
                checkGroupAdmin
              ) && (
                <div className="flex items-center bg-sky-600 text-white py-2 px-4 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300">
                  <FaUserCircle className="mr-2 text-xl" />
                  <span className="font-semibold text-md">Utilisateur</span>
                </div>
              )}
          </div>

          <div className="mr-4 flex items-center space-x-4 bg-red-500 text-white px-6 py-2 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
            <FiServer className="w-5 h-5" />
            <p className="font-semibold text-sm md:text-base">
              Environnement Test
            </p>
          </div>

          {/* Right-Side Login Component */}
          <div className="flex items-center space-x-4">
            {isSignedIn && (checkGroupAdmin || checkGroupRecMensuelle || checkGroupSeancePlacement || checkGroupAntCriminels) && (
              <NavLink
                to="/gestionDonnéesFinancières"
                title="Paramètres Finance"
                className={({ isActive }) =>
                  `text-xl transition duration-200 ${
                    isActive ? "text-black" : "text-gray-700 hover:text-black"
                  }`
                }
              >
                <FiSettings />
              </NavLink>
            )}

            {isSignedIn ? (
              <Login className="login" />
            ) : (
              <mgt-login class="login" />
            )}
          </div>
        </nav>
        <>
          {showWarning && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded shadow text-center">
                <p className="text-lg font-semibold mb-4">
                  Vous serez déconnecté dans{" "}
                  <span className="text-red-600 font-bold">{countdown}</span>{" "}
                  secondes.
                </p>
              </div>
            </div>
          )}
        </>
        <div className="app">
          <header></header>
        </div>
        <Outlet />
      </main>
    </div>
  );
}

export default Header;
